import { SddDetails, useCustomAddressDrawerStore } from '@libs/shared-ui';

import { useSddDeliveryStatus } from '../../model';

export const SddDeliveryDetails = () => {
    const { isLoading, streetAddress, minimumCaseQty, isError, availableStock, isDoorDashAvailable } =
        useSddDeliveryStatus();
    const openDrawer = useCustomAddressDrawerStore(state => state.open);

    if (isError) return null;

    return (
        <SddDetails
            className="delivery-details__container"
            emphasizeAddress
            isLoading={isLoading}
            streetAddress={streetAddress}
            availableStock={availableStock}
            minimumCaseQty={minimumCaseQty}
            isDoorDashAvailable={isDoorDashAvailable}
            onOpenAddressDrawer={openDrawer}
        />
    );
};
